import { getCookie } from './cookies';

const AUTH_C2_COOKIE_NAME = 'info_c2';

class MembershipUtils {
  static get loggedIn() {
    return Boolean((getCookie(AUTH_C2_COOKIE_NAME) || '').toString().trim());
  }
}

export default MembershipUtils;
